/**
 * ROC 7
 * Copyright 2017 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Upcharges/Upcharges',[
    'global/all',

    // inject enabled upcharges
    // customize as needed for the project
    'modules/Upcharges/Impl/RushOrderUpcharge',
    'modules/Upcharges/Impl/GiftWrapUpcharge',
    'modules/Upcharges/Impl/TextEngravingUpcharge'

], function (Roc) {
    'use strict';
});

